import { z } from 'zod';

import { zodTimeStamp } from '@/utils/zodUtils';

export const EnforcementStatementSchema = z.object({
  id: z.string(),
  location_id: z.string(),
  counterparty_customer_id: z.string(),
  agreement_changed_in_period: z.boolean(),
  operator_pct: z.number(),
  paid_invoices: z.number(),
  ledger_invoices: z.number(),
  collected_cents: z.number(),
  operator_share_cents: z.number(),
  tax_cents: z.number(),
  notices_mailed: z.number(),
  per_notice_recovery_cents: z.number(),
  expected_per_notice_recovery_cents: z.number(),
  refunded_invoices: z.number(),
  refund_cents: z.number(),
  disputed_invoices: z.number(),
  dispute_cents: z.number(),
  disputes_credited: z.number(),
  dispute_credit_cents: z.number(),
  net_payable_cents: z.number(),
  period_start: zodTimeStamp,
  status: z.string(),
  carried_in_cents: z.number(),
  amount_due_cents: z.number(),
  approved_at: zodTimeStamp.nullable(),
  paid_at: zodTimeStamp.nullable(),
});

export type EnforcementStatement = z.infer<typeof EnforcementStatementSchema>;

export const EnforcementStatementListSchema = z.object({
  statements: z.array(EnforcementStatementSchema),
});

export const EnforcementStatementSkipSchema = z.object({
  location_id: z.string(),
  reason: z.string(),
});

export type EnforcementStatementSkip = z.infer<
  typeof EnforcementStatementSkipSchema
>;

export const SaveEnforcementStatementsResultSchema = z.object({
  statements: z.array(EnforcementStatementSchema),
  skipped: z.array(EnforcementStatementSkipSchema),
});

export type SaveEnforcementStatementsResult = z.infer<
  typeof SaveEnforcementStatementsResultSchema
>;
